import { onCLS, onINP, onLCP, onFCP, onTTFB, type Metric } from 'web-vitals';

// Initialize monitoring (placeholder for future analytics setup)
export function initMonitoring() {
  console.log('Monitoring system ready (Sentry removed)');
}

// Web Vitals monitoring
function sendToAnalytics(metric: Metric) {
  // Log web vitals for debugging
  console.log(`[Web Vitals] ${metric.name}:`, {
    value: metric.value,
    rating: metric.rating,
  });

  // In production, you can send to your analytics endpoint
  // Example: posthog.capture('web-vital', { metric: metric.name, value: metric.value, rating: metric.rating });
}

export function initWebVitals() {
  // Monitor all Core Web Vitals
  onCLS(sendToAnalytics);  // Cumulative Layout Shift
  onINP(sendToAnalytics);  // Interaction to Next Paint (replaces FID)
  onLCP(sendToAnalytics);  // Largest Contentful Paint
  onFCP(sendToAnalytics);  // First Contentful Paint
  onTTFB(sendToAnalytics); // Time to First Byte

  console.log('Web Vitals monitoring initialized');
}

// Custom event tracking
export function trackEvent(eventName: string, properties?: Record<string, unknown>) {
  console.log(`[Analytics] ${eventName}`, properties);

  // In production, you could send to PostHog, Mixpanel, etc.
  // Example: posthog.capture(eventName, properties);
}

// Track page views
export function trackPageView(path: string) {
  trackEvent('page_view', { path });
}

// Track user errors (non-fatal)
export function trackError(error: Error, context?: Record<string, unknown>) {
  console.error('[Error Tracking]', error, context);

  // In production, you could send to your error tracking service
  // Example: posthog.capture('error', { error: error.message, context });
}

// Performance monitoring utilities
export function measurePerformance(name: string) {
  const startTime = performance.now();

  return {
    end: () => {
      const duration = performance.now() - startTime;
      console.log(`[Performance] ${name}: ${duration.toFixed(2)}ms`);

      if (import.meta.env.PROD && duration > 1000) {
        // Log slow operations (>1s)
        console.warn(`[Performance] Slow operation: ${name} (${duration.toFixed(2)}ms)`);
      }

      return duration;
    },
  };
}
